import { render, staticRenderFns } from "./SameOrdersPlushies.vue?vue&type=template&id=4e8c9c4b&scoped=true&"
import script from "./SameOrdersPlushies.vue?vue&type=script&lang=ts&"
export * from "./SameOrdersPlushies.vue?vue&type=script&lang=ts&"
import style0 from "./SameOrdersPlushies.vue?vue&type=style&index=0&id=4e8c9c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c9c4b",
  null
  
)

export default component.exports